module.exports = __webpack_public_path__ + "static/fresno_county.05543080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public_sector_logos/fresno_county.png
// module id = 2221
// module chunks = 61762850755587